// src/integration/growth/attribution.ts — install attribution (Play Install Referrer; collects no GAID).
//
// Gated by isGrowthSdkAllowed('attribution'); native-only. The real read is a dynamic import of the
// install-referrer plugin at ACTIVATION. The referrer string is decoded SERVER-side (campaign/source);
// the client only forwards it. No-op stub until the plugin is installed.

import type { GrowthInitResult } from './types';

export async function initAttribution(): Promise<GrowthInitResult> {
  // ACTIVATION (when the Play Install Referrer plugin is installed + consent + dataSafety green):
  //   const ref = await import('<install-referrer-plugin>');
  //   const { referrer } = await ref.InstallReferrer.getReferrer();
  //   // POST referrer to the backend for server-side decode; never store the raw string client-side.
  //   return { active: true, reason: 'install referrer read' };
  return { active: false, reason: 'install-referrer plugin not installed (activation pending)' };
}
